function validateEmail (email) {
  const re = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/
  return re.test(email)
}

function validatePhone (phone) {
  return phone.length >= 10
}

function validate (value, type) {
  switch (type) {
    case 'email' : return validateEmail(value)
    case 'phone' : return validatePhone(value)
    default: return true
  }
}

export {
  validate,
  validateEmail
}